import React from 'react'
import Input from './../input'
import { PROTOCOL } from './../../lib/helper'
import { Form } from 'formsy-react'
import _ from 'underscore'
import qs from 'qs'
import PropTypes from 'prop-types'
import { sanitize } from "dompurify"
import WPCOMTestimonial from './wpcomtestimonial'

class WPCOMForm extends React.Component {
	constructor(props){
		super(props)
		this.state = {advancedOptions: false}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
		this.toggleAdvancedOptions = this.toggleAdvancedOptions.bind(this)
	}

	UNSAFE_componentWillMount(){
		this.setToggle()
	}

	getLocationQuery() {
		const { history } = this.props
		const { location } = history
		return qs.parse(location.search, {ignoreQueryPrefix: true})
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	setToggle() {
		const { fields } = this.props
		let setAdvancedOptions
		if (fields['selectedDirectories'] && !_.isEmpty(fields['selectedDirectories'])) setAdvancedOptions = true
		if (fields['selectedTables'] && !_.isEmpty(fields['selectedTables'])) setAdvancedOptions = true
		if (fields['httpauth_src_user'] || fields['httpauth_src_password']) setAdvancedOptions = true
		if (setAdvancedOptions) this.toggleAdvancedOptions(true)
	}

	toggleAdvancedOptions(state) {
		const { getDirectoryList, getTablesList } = this.props
		if (state) {
			getDirectoryList()
			getTablesList()
		}
		this.setState({advancedOptions: state})
	}

	showDirectoryList() {
		const { directoryList, changeSelection, directoriesSelectAllDisabled, allDirectoriesSelected, selectAllDirectories } = this.props
		if (directoryList){
			let list = directoryList.map((directory, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className="customcheck">{directory.name}
						<input
							name={directory.name}
							type="checkbox"
							checked={directory.selected}
							onChange={changeSelection.bind(null, directory.name)}
							disabled={directory.isDisabled}
						/>
						<span className="checkmark"></span>
					</label>
				</li>
			})
			list.unshift(<li key='select-all' style={{listStyle: "none"}}>
				<label className="customcheck">Select All
					<input
						namee='select-all'
						type="checkbox"
						disabled={directoriesSelectAllDisabled}
						checked={allDirectoriesSelected}
						onChange={selectAllDirectories.bind(null)}
					/>
					<div className="checkmark"></div>
				</label>
			</li>)
			return list
		}
	}
	
	showTablesList = () => {
		const { tablesList, changeTableSelection, selectAllTables, allTablesSelected, tablesSelectAllDisabled } = this.props
		if (tablesList) {
			const tableContent = tablesList.map((table, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className="customcheck">{table.name}
						<input
							name={table.name}
							type="checkbox"
							checked={table.selected}
							onChange={changeTableSelection.bind(null, table.name)}
							disabled={table.isDisabled}
						/>
						<span className="checkmark"></span>
					</label>
				</li>
			})
			tableContent.unshift(<li key='select-all' style={{ listStyle: "none" }}>
				<label className="customcheck">Select All
					<input
						name='select-all'
						type="checkbox"
						disabled={tablesSelectAllDisabled}
						checked={allTablesSelected}
						onChange={selectAllTables.bind(null)}
					/>
					<span className="checkmark"></span>
				</label>
			</li>)
			return tableContent
		}
	}

	formatError = (ErrorComponent) => {
		let errorMessage = ErrorComponent.props.error_message

		if (errorMessage.includes('contact support')) {
			const strReplace = errorMessage.includes('contact support team') ? 'contact support team' : 'contact support'
			errorMessage = errorMessage.replace(
				`${strReplace}`,
				'<a href="https://wordpress.com/help" target="_blank" rel="noopener noreferrer" style="color: inherit">contact us</a>'
			)
		} else {
			if (!errorMessage.trim().endsWith('.')) errorMessage += '.'
			errorMessage += ' <a href="https://wordpress.com/help" target="_blank" rel="noopener noreferrer" style="color: inherit">Contact us</a> if you\'re still having trouble.'
		}

		return (
			<ErrorComponent.type
				{...ErrorComponent.props}
				error_message={
					<span
						dangerouslySetInnerHTML={{
							__html: sanitize(errorMessage, {ALLOWED_ATTR: ['href', 'target', 'rel', 'style']}),
						}}
					/>
				}
			/>
		)
	}

	render() {
		const { migrate, handleSubmit, error, fetchingDirectories, fetchingTables } = this.props
		const { advancedOptions } = this.state
		const expandedClass = advancedOptions ? "wpcom-migration-foldable--expanded" : ""
		const advancedOptionsIcon = advancedOptions ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down"
		return <div className="wpcom">
			<div className="wpcom-migration-container">
				<main className="wpcom-migration-content">
					<h1>Start your migration</h1>
					<p>Let&apos;s get started. Just drop your migration key below, customize your options in Advanced Settings, and you&apos;re all set.</p>
					<Form onSubmit={handleSubmit} className="wpcom-migration-form">
						{ error ? <div className="pb-2 font12">{this.formatError(error)}</div> : null }
						<div className="wpcom-migration-section">
							<div className="wpcom-migration-input-group">
								<div className="row">
									<div className={this.getClassName('bv_migration_key')}>
										<Input
											id="wpcom-migration-key"
											type="text"
											name="bv_migration_key"
											title="Migration Key"
											placeholder="Enter your migration key"
											classname="mb-0"
											value={this.fetchValue('bv_migration_key')}
										/>
									</div>
								</div>
								<div className="wpcom-migration-input-info">
									Need a migration key? <a
										href={`https://wordpress.com/setup/hosted-site-migration?ref=wpcom-migrate-plugin&from=${migrate.get('source_site')}`}
										target="_blank"
										rel="noreferrer"
									>
										Get it on WordPress.com
									</a>
								</div>
							</div>
						</div>
						<div className="row hide-field">
							<Input
								type="hidden"
								name="migrate"
								value="automattic"
								title=""
								placeholder=""
								classname=""
							/>
							<Input
								type="hidden"
								title=""
								name="protocol"
								placeholder=""
								classname=""
								value={PROTOCOL.TOKEN}
							/>
						</div>
						<div className={`wpcom-migration-section wpcom-migration-foldable ${expandedClass}`}>
							<div className="wpcom-migration-foldable__header" onClick={() => this.toggleAdvancedOptions(!advancedOptions)}>
								<div className="wpcom-migration-foldable__header-content">
									<div className="wpcom-migration-foldable__title">Advanced options</div>
									<div className="wpcom-migration-foldable__description">Add additional credentials or customize your migration.</div>
								</div>
								<div>
									<span><i className={`${advancedOptionsIcon} font24`}/></span>
								</div>
							</div>
							<div className="wpcom-migration-foldable__body">
								<div className="wpcom-migration-section">
									<div className="wpcom-migration-section__title">Source site credentials</div>
									<div className="wpcom-migration-section__description">Provide the following credentials if this site is password protected.</div>
									<div className="wpcom-migration-section__inner" style={{paddingBottom: '16px'}}>
										<div className="wpcom-migration-input-group">
											<div className="row">
												<div className={this.getClassName('httpauth_src_user')}>
													<Input
														type="text"
														name="httpauth_src_user"
														title="Username"
														id="wpcom-migration-username"
														placeholder="Enter your username"
														value={this.fetchValue('httpauth_src_user')}
													/>
												</div>
											</div>
										</div>
										<div className="wpcom-migration-input-group">
											<div className="row">
												<div className={this.getClassName('httpauth_src_password')}>
													<Input
														type="password"
														title="Password"
														name="httpauth_src_password"
														id="wpcom-migration-password"
														placeholder="Enter your password"
														value={this.fetchValue('httpauth_src_password')}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="wpcom-migration-section">
									<div className="wpcom-migration-section__title">Customize migration</div>
									<div className="wpcom-migration-section__description">Pick the tables and folders you would like to migrate.</div>
									<div className="wpcom-migration-section__title">Folders</div>
									<div className="wpcom-migration-section__inner">
										<div className="wpcom-migration-input-group wpcom-migration-input-group--checkbox">
											{fetchingDirectories ? <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading"/> : this.showDirectoryList()}
										</div>
									</div>
									<div className="wpcom-migration-section__title">Database tables</div>
									<div className="wpcom-migration-section__inner">
										<div className="wpcom-migration-input-group wpcom-migration-input-group--checkbox">
											{fetchingTables ? <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading"/> : this.showTablesList()}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="wpcom-migration-section">
							<button type="submit">Start migration</button>
						</div>
					</Form>
				</main>
				<WPCOMTestimonial migrate={migrate} />
			</div>
		</div>
	}
}

WPCOMForm.propTypes = {
	handleSubmit: PropTypes.func,
	fields: PropTypes.object,
	errors: PropTypes.array,
	error: PropTypes.object,
	directoryList: PropTypes.array,
	changeSelection: PropTypes.func,
	getDirectoryList: PropTypes.func,
	fetchingDirectories: PropTypes.bool,
	loading: PropTypes.bool,
	history: PropTypes.object,
	getTablesList: PropTypes.func,
	tablesList: PropTypes.array,
	changeTableSelection: PropTypes.func,
	selectAllTables: PropTypes.func,
	allTablesSelected: PropTypes.bool,
	tablesSelectAllDisabled: PropTypes.bool,
	fetchingTables: PropTypes.bool
}

export default WPCOMForm
